import React from 'react'
import useIndividualOverviewStyles from "./individual-overview.styles";
import STATIC_TEXT from '../../../content/common.json';
import { WelcomeFooterWrapper } from '../welcome-footer-wrapper';
import PRO_TIP_ICON from '../../../assets/pro-tip-welcomescreen.svg';
export const IndividualOverview: React.FC = (): JSX.Element => {
 const classes = useIndividualOverviewStyles();
    return (
      
       <WelcomeFooterWrapper
        className="footer__content_process"
        proTipIcon={PRO_TIP_ICON}
        proTipLabel={STATIC_TEXT.welcome.applicationInfo.proTipLabel}
        proTipDescription={STATIC_TEXT.welcome.processPreview.proTipDescription}
        buttonLabel={STATIC_TEXT.welcome.navigationButton.next_start_app}
        hideBackButton
      />
    );
}
